<template>
  <WdsInputArea
    v-model="localModelValue"
    :info="fieldTyped.description ?? undefined"
    :required="required"
    :disabled="
      props.forceDisabled || (props.forceEnabled ? false : !fieldTyped.viewerCanManageFieldValues)
    "
    :error="error"
    resizeable
    height="36px"
  >
    <template #label>
      {{ fieldTyped.title }}
      <span v-if="required" class="tw-text-indigo-500 tw-font-bold">*</span>
      <WdsTag v-else sm class="tw-ml-1">{{ $t('Optional') }}</WdsTag>
      <CustomFieldVisibilityBadge
        :applies-to="fieldTyped.appliesTo"
        :shared-with-clients="fieldTyped.sharedWithClients"
        :shared-with-staffing-agencies="fieldTyped.sharedWithStaffingAgencies"
        :managed-elsewhere="!fieldTyped.viewerOwnsField"
        :owner-account-name="fieldTyped.account?.name"
      />
    </template>
  </WdsInputArea>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { WdsInputArea, WdsTag } from '@worksome/wds-components'
import { FieldableFormCustomFieldFragment } from '@/components/Fieldable/graphql/fragments'
import { useFragment } from '@/gql'
import { CustomFieldTypeValueInput } from '@/gql/graphql'
import useIsRequiredField from '@/components/Fieldable/composables/useIsRequiredField'
import { FieldableCustomFieldProps } from '@/components/Fieldable/types'
import { $t } from '@/composables/translation'
import CustomFieldVisibilityBadge from '@/components/Fieldable/CustomFieldVisibilityBadge.vue'

const emits = defineEmits(['update:model-value'])

const props = defineProps<FieldableCustomFieldProps>()

const fieldTyped = computed(() => useFragment(FieldableFormCustomFieldFragment, props.field))
const required = useIsRequiredField(props.field)

const localModelValue = computed<string>({
  get: (): string => props.modelValue?.freeText?.value ?? '',
  set: (input: string) => {
    const value = input === '' ? null : input

    emits('update:model-value', {
      freeText: {
        id: fieldTyped.value.id,
        value,
      },
    } as CustomFieldTypeValueInput)
  },
})
</script>
